import { LookupItem } from "@data-types";
import {
	CountryDataType,
	LanguageDataType,
	RegionDataType,
} from "@data-types/membership/registration";
import { httpClient, getApplicationHeaders } from "@utils";

class PlatformPartnerLookupApiService {
	static get baseUrl() {
		return `${WEBPACK_BASE_ADDRESS}platform/tw/partners/lookups`;
	}

	static getRequestHeaders = () => {
		const appHeaders = getApplicationHeaders();
		appHeaders["Content-Type" as keyof HeadersInit] = "application/json";
		return appHeaders;
	};

	static findTitles(): Promise<LookupItem[]> {
		return httpClient.get(
			`${this.baseUrl}/user-titles?translate=true`,
			this.getRequestHeaders(),
			{
				responseType: "json",
			}
		);
	}

	static findCountries(): Promise<CountryDataType[]> {
		return httpClient.get(
			`${this.baseUrl}/countries?sort=name|asc&fields=id,name,nationality,abrv&rpp=1000&translate=true`,
			this.getRequestHeaders(),
			{
				responseType: "json",
			}
		);
	}

	static findLanguages(isos: string): Promise<LanguageDataType[]> {
		return httpClient.get(
			`${this.baseUrl}/contact-languages?sort=name|asc&rpp=1000&translate=true&isos=${isos}`,
			this.getRequestHeaders(),
			{
				responseType: "json",
			}
		);
	}

	static findCountryRegions(): Promise<RegionDataType[]> {
		return httpClient.get(
			`${this.baseUrl}/regions?sort=name|asc&rpp=1000&translate=true`,
			this.getRequestHeaders(),
			{
				responseType: "json",
			}
		);
	}
}

export default PlatformPartnerLookupApiService;
